// extracted by mini-css-extract-plugin
export default {"comment":"task__task-right-menu__components__task-executor-comment__comment","saveComment":"task__task-right-menu__components__task-executor-comment__saveComment"};